import "./SubNavDesktop.scss";

import React, {
  useCallback,
  useContext,
  useEffect
} from "react";

import { Media } from "design-system/shared/contexts/media/MediaContext";
import { UiStateContext } from "design-system/shared/contexts/ui-state/UiStateContext";
import PhLink from "design-system/shared/components/ph-link/ph-link";
import {
  FeatureToggle,
  MainNavigationItem,
  SubNavigationMenusData
} from "design-system/shared/models/app-data-model";

import {
  ChevronRight,
  KeyboardArrowDown
} from "@mui/icons-material";
import { Button } from "@mui/material";
import { getContentHubDamAsset } from "../../../shared/utils/get-contenthub-dam-asset";
import useFeatureToggle from "../../../shared/hooks/use-feature-toggle/useFeatureToggle";

export type SubNavDesktopProps = {
  subNavigationMenus: SubNavigationMenusData;
  featureToggles: FeatureToggle[];
};

const SubNavDesktop: React.FC<SubNavDesktopProps> = ({ subNavigationMenus, featureToggles }: SubNavDesktopProps) => {
  const uiStateContext = useContext(UiStateContext);
  const isSlfsvc226On = useFeatureToggle('SLFSVC-226', featureToggles);

  const initialize = () => {
    if (isSlfsvc226On) {
      uiStateContext.setSubNavDropdownOpen?.(false);
      uiStateContext.setSubNavOpenIndex?.(-1);
    }
  }

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleDropdown = useCallback(
    (dropdownData: MainNavigationItem, index: number): void => {
      uiStateContext.setDropDownData?.(dropdownData);

      if (uiStateContext.subNavOpenIndex === index) {
        uiStateContext.setSubNavDropdownOpen?.(false);
        uiStateContext.setSubNavOpenIndex?.(-1);
      } else {
        uiStateContext.setSubNavDropdownOpen?.(true);
        uiStateContext.setSubNavOpenIndex?.(index);
      }
    },
    [uiStateContext]
  );

  const subNavLeftButtons = subNavigationMenus?.main_navigation_items && subNavigationMenus?.main_navigation_items.map((navItem, index) => {
    return navItem.reference.length > 0 && 'modular_blocks' in navItem.reference[0] ?
      <Button onClick={() => toggleDropdown(navItem, index)}
        endIcon={<KeyboardArrowDown className={`icon ${uiStateContext.subNavDropdownOpen && uiStateContext.subNavOpenIndex === index ? 'open' : ''}`} />}
        key={index}
        variant='text'
      >{navItem.title}</Button> :
      <PhLink
        key={index}
        className='text'
        href={navItem.reference[0]?.url || getContentHubDamAsset(navItem.reference[0]?.contenthub_asset)?.url || '/'}
      >{navItem.title}</PhLink>;
  });

  const subNavRightButtons = subNavigationMenus?.right_nav && subNavigationMenus.right_nav.map((navItem, index) => {
    if (navItem.button && navItem.button.reference && navItem.button.reference.length > 0) {

        return (
          <PhLink
            key={index}
            className='text'
            href={navItem.button.reference[0]?.url || getContentHubDamAsset(navItem.button.reference[0]?.contenthub_asset)?.url || '/'}
          >{navItem.button.label}</PhLink>
        );
    }
    return null;
  });

  return (
    <>
      <Media greaterThanOrEqual='md' className="sub-nav-desktop">
        <div className='subnav-left'>
          {subNavigationMenus?.title && subNavigationMenus?.title.toLowerCase() !== 'home' &&
            <div className='subnav-title'>{subNavigationMenus?.title}
              <ChevronRight />
            </div>
          }
          {subNavLeftButtons}
        </div>
        <div className='subnav-right'>
          {subNavRightButtons}
        </div>
      </Media>
    </>
  );
};

export default SubNavDesktop;
